/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancel_SuccessInputs */

const en_cancel_success = /** @type {(inputs: Cancel_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your subscription will be cancelled at the end of the current billing period.`)
};

const fr_cancel_success = /** @type {(inputs: Cancel_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre abonnement sera annulé à la fin de la période de facturation en cours.`)
};

const de_cancel_success = /** @type {(inputs: Cancel_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihr Abonnement wird zum Ende des aktuellen Abrechnungszeitraums gekündigt.`)
};

const it_cancel_success = /** @type {(inputs: Cancel_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'abbonamento verrà annullato al termine del periodo di fatturazione corrente.`)
};

const ru_cancel_success = /** @type {(inputs: Cancel_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваша подписка будет аннулирована по окончании текущего расчетного периода.`)
};

const es_cancel_success = /** @type {(inputs: Cancel_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Su suscripción se cancelará al final del período de facturación actual.`)
};

const zh_cn2_cancel_success = /** @type {(inputs: Cancel_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的订阅将在当前计费周期结束时取消。`)
};

const ja_cancel_success = /** @type {(inputs: Cancel_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在の請求期間の終了時にサブスクリプションはキャンセルされます。`)
};

const hi_cancel_success = /** @type {(inputs: Cancel_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्तमान बिलिंग अवधि के अंत में आपकी सदस्यता रद्द कर दी जाएगी।`)
};

const pt_pt2_cancel_success = /** @type {(inputs: Cancel_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua assinatura será cancelada ao final do período de faturamento atual.`)
};

/**
* | output |
* | --- |
* | "Your subscription will be cancelled at the end of the current billing period." |
*
* @param {Cancel_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const cancel_success = /** @type {((inputs?: Cancel_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancel_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_cancel_success(inputs)
	if (locale === "de") return de_cancel_success(inputs)
	if (locale === "it") return it_cancel_success(inputs)
	if (locale === "ru") return ru_cancel_success(inputs)
	if (locale === "es") return es_cancel_success(inputs)
	if (locale === "zh-CN") return zh_cn2_cancel_success(inputs)
	if (locale === "ja") return ja_cancel_success(inputs)
	if (locale === "hi") return hi_cancel_success(inputs)
	if (locale === "pt-PT") return pt_pt2_cancel_success(inputs)
	return en_cancel_success(inputs)
});